'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (type) {
    switch (type) {
        case _.CHART_TYPE_GAUGE:
            return (0, _gauge2.default)();
            break;
        default:
            return undefined;
    }
};

var _gauge = require('./gauge');

var _gauge2 = _interopRequireDefault(_gauge);

var _ = require('..');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/adapters/dhis_highcharts/pane/index.js
 ** module id = 205
 ** module chunks = 0 1
 **/